/*eslint-disable max-len*/
export default {
    Error: {
      UAuthError: {
        8: 'El Usuario ya existe',
        9: 'Faltan campos obligatorios',
        10: 'ID de Usuario invalido',
        11: 'Fallo al enviar invitacion',
        12: 'Token invalido o vencido',
        13: 'Credencial invalida'
      }
    },
  
    Form: {
      Toolbar: {
        Continue: 'Continuar',
        Cancel: 'Cancelar',
        Edit: 'Editar',
        Delete: 'Eliminar',
        DelModal: {
          Header: 'Eliminar Item',
          Body: 'Desea eliminar este item permanentemente? Si es asi, presione Continuar sino Cancelar.'
        }
      },
      Actions: {
        Add: 'Agregar',
        Save: 'Guardar',
        Cancel: 'Cancelar',
        Close: 'Regresar',
        Ok: 'Ok'
      },
      Validations: {
        Required: 'Requerido',
        Invalid: 'Valor invalido',
        InvalidRegion: 'Region invalida',
        InvalidEmail: 'Formato de email invalido',
        MaxLen: 'Maxima cantidad de caracteres es {0}',
        MinLen: 'Minimum {0} Characters Required',
        InvalidNum: 'Number only',
        ZeroOrMore: 'Numeros unicamente (mayor o igual a 0)',
        MoreThanZero: 'Numeros positivos unicamente (mayor a 0)',
      }
    },
    ConfirmModal: {
        Continue: 'Continue',
        Cancel: 'Cancel'
      },
  
    RegionPicker: {
      region: 'Region',
      command: 'Comando'
    },
  
    MemberBadge: {
      External: 'Externo',
      Internal: 'Interno'
    },
  
    MemberOption: {
      member_since: 'Miembro desde',
      already_in_group: 'Ya existe en el grupo',
    },
  
    Login: {
      Username: 'Email',
      Password: 'Contraseña',
      Submit: 'Ingresar',
      timeOutPanel: {
        header: 'Su sesion expirara si se mantiene inactiva!',
        body: 'Sera deslogueado automaticamente en ',
        unit: 'segundos'
      },
      sessionTimeOutError: 'Su sesion ha expirado',
      continueSessionText: 'Continuar',
      missingInput: 'Debe ingresar su email y contraseña',
  
      apiResponseErrors: {
        401: 'Credenciales Invalidas',
        400: 'Fallo validacion'
      }
    },

    ForgotPassword: {
        link: 'Forgot your password?',
        title: 'Forgot Password',
        email: 'Email',
        Send: 'Send',
        Close: 'Close',
        Processing: 'Processing...',
        InvalidEmail: 'Your request for a new password cannot be processed, not a valid email id',
        RequestSent: 'Your request is processed successfully'
      },
    Home: {
      title: 'Apps Home',
      modules: {
        UBLT: 'Herramienta de carga por bulto (UBLT)',
        UBET: 'Herramienta de extraccion por bulto (UBET)',
        UFLOW: 'Administracion de Casos (UFLOW)',
        USERMNG: 'Administracion de usuarios',
        IMGUPLOADER: 'Cargar imagenes'
      }
    },
  
    Editor: {
      theme: 'Tema'
    },
  
    ContentPermission: {
      NoBLTRolesFound: 'Ud no tiene permisos para acceder a las aplicaciones de Unity. Por favor contacte al <a href="mailto:UnitySupportTeam@DNB.com?subject=Unity Access Request">Unity support team</a>, aclarando los mercados que desea acceder',
      WelcomeMessage: 'Bienvenido a Unity'
    },
  
    Footer: {
      Terms: 'Terminos',
      PrivacyPolicy: 'Politica de privacidad',
      Copyright: 'Â© Dun &amp; Bradstreet, Inc. 2017. Todos los derechos reservados.'
    },
  
    Header: {
      settings: 'Settings',
      logout: 'Logout',
      title: 'Unity',
      options: 'Opciones',
      reader: 'D&amp;B Unity',
      wiki: 'Wiki (Ayuda)'
    },
  
    MultiStep: {
      nextButton: 'Siguiente',
      previousButton: 'Anterior',
      nextTextOnFinalActionStep: 'Guardar'
    },
  
    FileInput: {
      placeHolder: 'Seleccione un archivo'
    },
  
    menuLinks: {
      main: 'Portal Home',
      UBET: 'Bulk Extract Tool (UBET)',
      UBET_tabs: {
        launcher: 'Launcher'
      },
    },
  
    SearchGrid: {
      messageSearch: 'Buscar..',
      messageSearching: 'Buscando...',
      messageLoadMore: 'Desplazarse para cargar mas registros',
      messageNoMatches: 'No hay registros para su consulta.'
    },
  
    UBET: {
        linkText: 'Launch UBET Here (Opens in a new tab)'
      },
     
      
  }
  